import type { RegionId } from "@lib/domain"

export interface AppConfig {
  /** Region shown when no preference is stored yet. */
  readonly defaultRegionId: RegionId
  /** Persistence keys. */
  readonly prefKeys: {
    readonly activeRegion: string
    readonly cameraByRegion: (id: RegionId) => string
    readonly language: string
  }
}

export const DEFAULT_APP_CONFIG: AppConfig = {
  defaultRegionId: "vrindavan",
  prefKeys: {
    activeRegion: "navigator.activeRegion",
    cameraByRegion: (id) => `navigator.camera.${id}`,
    language: "navigator.language",
  },
}
